export default __webpack_public_path__ + "static/media/BinIcon.f32b0c3b.svg";